// extracted by mini-css-extract-plugin
export var rootButton = "vtjt";
export var rootFieldsWrapper = "-JK7";
export var rootFooter = "_4qAf";
export var rootForm = "MtMR";
export var rootFormItemsWrapper = "JsIc";
export var rootHeading = "mRHF";
export var rootLabel = "d6Zc";